import { MDBDataTable } from "mdbreact";
import { React, useMemo, useState, useEffect, useContext } from "react";
import { API_BASE_URL } from "../../utils/config";
import axios from "axios";
// import { FaImage, FaUserEdit } from "react-icons/fa";
// import { MdDeleteForever } from "react-icons/md";
import MdDeleteForever from "../../Img/delete.png";
import FaUserEdit from "../../Img/edit user.png";
import SideBar from "../SideBar";
import TopNavBar from "../TopNavBar";
import Spinner from "../Spinner";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import GlobalContext from "../../context/GlobalContext";
import { Link } from "react-router-dom";
import CreateCategoryImg from "../../Img/manage category.png";
import UpdateCategoryImg from "../../Img/update.png";
import DetailsImg from "../../Img/info.png";
import UpdateImg from "../../Img/update.png";
import BackImg from "../../Img/back.png";
import SaveImg from "../../Img/save.png";
import CreateSubCatImg from "../../Img/subcategory.png";
import NewTopNavBar from "../NewTopNavBar";

const CreateCategories = () => {
  const {
    catetoryIconUptated,
    setCatetoryIconUptated,
    notificationCount,
    setNotificationCount,
  } = useContext(GlobalContext);
  const [apiResponse, setApiRespose] = useState([]);
  const [category, setCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [collaps, setCollaps] = useState(true);
  const [loader, setLoader] = useState(false);
  const [categoryModalShow, setCategoryModalShow] = useState(false);
  const [categoryLoading, setCtegoryLoading] = useState(false);
  const [subCategoryLoading, setSubCategoryLoading] = useState(false);
  const [subCategoryScreen, setSubCategoryScreen] = useState(false);
  const [categoryId, setCategoryId] = useState();
  const [show, setShow] = useState(false);
  const [openEditSubCat, setOpenEditSubCat] = useState(false);
  const [subCategoryName, setSubCtegoryName] = useState("");
  const [showCreateSubCategory, setShowCreateSubCategory] = useState(true);
  const [createSubCategoryShow, setCreateSubCategoryShow] = useState(false);
  const [editSubCategoryId, setEditSubCategoryId] = useState();
  const [editCategoryModalShow, setEditCategoryModalShow] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    id: "",
    parent_id: "",
  });
  const [categoryFormData, setCategoryFormData] = useState({
    name: "",
    id: "",
    image: "",
  });

  const [UpdatecategoryImage, setUpdateCategoryImage] = useState("");
  const [shortName, setShortName] = useState("");
  let bearerToken = localStorage.getItem("jwt_token");
  const config = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
  };
  const config2 = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "multipart/form-data",
    },
  };
  const changeCollapsState = () => {
    if (collaps) {
      setCollaps(false);
    } else {
      setCollaps(true);
    }
  };

  const getAllTheCategories = () => {
    const apiUrl = `${API_BASE_URL}/wp-json/custom-category/v1/get-all-categories`;
    axios
      .get(apiUrl, config)
      .then((res) => {
        setApiRespose(res.data);
        // console.log("allCatagory=", res.data)

        let filterData = res.data.filter((data) => {
          if (data.parent == 0) {
            return data;
          }
        });
        setCategory(filterData);

        console.log(filterData);
        setLoader(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllSubCategories = (id, value, categoryName) => {
    // alert(categoryName)
    if (categoryName) {
      localStorage.setItem("categoryName", categoryName);
      setCategoryName(categoryName);
    }

    setSubCategoryScreen(value);
    setCategoryId(id);
    const apiUrl = `${API_BASE_URL}/wp-json/category-api/v1/get-subcategories/?category_id=${id}&page=-1`;
    axios
      .get(apiUrl, config)
      .then((res) => {
        setApiRespose(res.data);
        // console.log("allCatagory=", res.data)

        setSubCategory(res.data);
        setLoader(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  console.log("112=", categoryName);

  const CategoryPage = () => {
    setSubCategoryScreen(false);
  };

  let categoryData = category
    ? category.map((data) => {
      let obj = {
        category: data.name,
        Image: data.image,
        author: data.unique_authors_count,
        article: data.post_count,
        id: data.id,
      };
      return obj;
    })
    : "";

  let subCategoryData = subCategory
    ? subCategory.map((data) => {
      let obj = {
        category: data.name,
        // Image: data.image,
        author: data.unique_authors_count,
        article: data.post_count,
        id: data.id,
      };
      return obj;
    })
    : "";

  const rolles = localStorage.getItem("roles");

  // const handleDelete = (category_id) => {

  //     const confirmed = window.confirm(
  //         "Are you sure you want to delete this Category?"
  //     );
  //     if (!confirmed) {
  //         return;
  //     }
  //     axios.delete(`${API_BASE_URL}/wp-json/custom/v1/delete-category/${category_id}`, config).then((res) => {
  //         console.log(res.data)
  //         toast.success(res.data.message);
  //         setCtegoryLoading(categoryLoading ? false : true)
  //     }).catch((err) => {
  //         // console.log(err)
  //         toast.error(err.response.data.message)
  //     })

  // }

  const CustomToastWithLinkDeleteCategory = () => (
    <div>
      To delete this parent category, please,
      <Link className="px-1" to="/table-posts">
        Click here
      </Link>
      to transfer associated articles and delete subcategories within it.
    </div>
  );

  const handleDelete = (id, category_name) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this Category?"
    );
    if (!confirmed) {
      return;
    }

    axios
      .get(`${API_BASE_URL}/wp-json/wp/v2/categories/${id}`, config)
      .then((res) => {
        console.log(res);
        if (res.data.count > 0) {
          toast.error(CustomToastWithLinkDeleteCategory);
        } else if (res.data.parent == 0) {
          let hasSubcategory = false;
          axios
            .get(`${API_BASE_URL}/wp-json/wp/v2/categories/`, config)
            .then((response) => {
              for (let i = 0; i < response.data.length; i++) {
                // console.log("parent=", res.data[i]);
                console.log("id=", id);
                if (response.data[i].parent == id) {
                  toast.error("Category contains sub category");
                  hasSubcategory = true;
                  break;
                }
              }

              //
              if (!hasSubcategory) {
                setCtegoryLoading(false);
                axios
                  .delete(
                    `${API_BASE_URL}/wp-json/wp/v2/categories/${id}?force=true`,
                    config
                  )
                  .then((response) => {
                    // Handle the response here
                    console.log("292=", response.data);
                    // setShowCreateCategory(true)
                    setCtegoryLoading(true);
                    setCategoryName("");
                    if (response.data.previous.parent > 0) {
                      toast.success("SubCategory Deleted Successfully");
                    } else {
                      toast.success("Category Deleted Successfully");
                      setCtegoryLoading(categoryLoading ? false : true);

                      // notification count start
                      setNotificationCount(notificationCount + 1);

                      let notification_count_specific_user = {
                        user_id: localStorage.getItem("current_user_Id"),
                        count_value: res.data.count_value + 1,
                      };
                      let notification_count = {
                        user_id: "",
                        count_value: notificationCount,
                        reflect_count: "all_admin",
                      };
                      if (notification_count.user_id == "") {
                        // post notification on usermeta start
                        axios
                          .post(
                            `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
                            notification_count,
                            config
                          )
                          .then((res) => {
                            console.log(res.data);
                          })
                          .catch((err) => {
                            console.log(err);
                          });
                      }
                      if (notification_count_specific_user.user_id != "") {
                        // post notification on usermeta start
                        axios
                          .post(
                            `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
                            notification_count_specific_user,
                            config
                          )
                          .then((res) => {
                            console.log(res.data);
                          })
                          .catch((err) => {
                            console.log(err);
                          });
                      }
                      // notification count end

                      // recomandation data

                      let notification_api_data = {
                        author: localStorage.getItem("display_name"),
                        event_type: "Delete Category",
                        category_name: category_name,
                        email: localStorage.getItem("userEmail"),
                        author_ids: localStorage.getItem("current_user_Id"),
                      };

                      axios
                        .post(
                          `${API_BASE_URL}/wp-json/custom/v1/insert-notification-data`,
                          notification_api_data,
                          config
                        )
                        .then((res) => {
                          console.log(res.data);
                        })
                        .catch((err) => {
                          console.log(err);
                        });

                      // recomandation data
                    }
                    setCatetoryIconUptated(catetoryIconUptated ? false : true);
                    console.log(response.data);
                  })
                  .catch((error) => {
                    console.log(error);
                    // toast.error(error?.response?.data.message)
                    // Handle any errors here
                  });
              }
              //
            })
            .catch((error) => {
              console.log(error);
              // toast.error(error?.response?.data.message)
              // Handle any errors here
            });
        } else {
          setCtegoryLoading(false);
          axios
            .delete(
              `${API_BASE_URL}/wp-json/wp/v2/categories/${id}?force=true`,
              config
            )
            .then((response) => {
              // Handle the response here
              // setShowCreateCategory(true)
              setCtegoryLoading(true);
              setCategoryName("");
              // console.log("328=", response.data)
              if (response.data.previous.parent > 0) {
                toast.success("SubCategory Deleted Successfully");
              } else {
                toast.success("Category Deleted Successfully");
              }
              setCatetoryIconUptated(catetoryIconUptated ? false : true);
              console.log(response.data);
            })
            .catch((error) => {
              console.log(error);
              // toast.error(error?.response?.data.message)
              // Handle any errors here
            });
        }
      });
  };
  const CustomToastWithLinkDeleteSubCategory = () => (
    <div>
      To delete this Sub category, please,
      <Link className="px-1" to="/table-posts">
        Click here
      </Link>
      to transfer associated articles.
    </div>
  );

  const handleDeleteSubcategory = (category_id, subCat) => {
    setSubCategoryLoading(true);

    const confirmed = window.confirm(
      "Are you sure you want to delete this SubCategory?"
    );
    if (!confirmed) {
      return;
    }
    axios
      .delete(
        `${API_BASE_URL}/wp-json/custom/v1/delete-category/${category_id}`,
        config
      )
      .then((res) => {
        console.log(res);
        if (res.data?.data?.status == 201) {
          toast.error(CustomToastWithLinkDeleteSubCategory);
        } else {
          console.log(res.data);
          toast.success(res.data.message);

          // notification count start
          setNotificationCount(notificationCount + 1);

          let notification_count_specific_user = {
            user_id: localStorage.getItem("current_user_Id"),
            count_value: res.data.count_value + 1,
          };
          let notification_count = {
            user_id: "",
            count_value: notificationCount,
            reflect_count: "all_admin",
          };
          if (notification_count.user_id == "") {
            // post notification on usermeta start
            axios
              .post(
                `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
                notification_count,
                config
              )
              .then((res) => {
                console.log(res.data);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          if (notification_count_specific_user.user_id != "") {
            // post notification on usermeta start
            axios
              .post(
                `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
                notification_count_specific_user,
                config
              )
              .then((res) => {
                console.log(res.data);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          // notification count end

          // recomandation data

          let notification_api_data = {
            author: localStorage.getItem("display_name"),
            // name: createUsersFormData.username,
            event_type: "Delete Subcategory",
            subcategory_name: subCat,
            email: localStorage.getItem("userEmail"),
            // user_role: createUsersFormData.selectedRole,
            author_ids: localStorage.getItem("current_user_Id"),
          };

          axios
            .post(
              `${API_BASE_URL}/wp-json/custom/v1/insert-notification-data`,
              notification_api_data,
              config
            )
            .then((res) => {
              console.log(res.data);
            })
            .catch((err) => {
              console.log(err);
            });

          // recomandation data
        }
        setSubCategoryLoading(false);
        // setSubCategoryLoading(subCategoryLoading ? false : true)
      })
      .catch((err) => {
        // setSubCategoryLoading(subCategoryLoading ? false : true)
        console.log(err);
        toast.error(err.response?.data?.message);
      });
  };
  // category
  const data = useMemo(
    () => ({
      columns: [
        // {
        //     label: '#',
        //     field: 'count',
        //     width: 300,
        //     sort: 'disabled',
        //     fixedHeader: true
        // },
        {
          label: "Image",
          field: "Image",
          width: 50,
          sort: "disabled",
          fixedHeader: true,
        },
        {
          label: "Category Name",
          field: "category",
          width: 300,
          sort: "",
          fixedHeader: true,
        },
        {
          label: "Authors",
          field: "author",
          width: 300,
          sort: "",
          fixedHeader: true,
        },
        {
          label: "Articles",
          field: "article",
          width: 300,
          sort: "",
          fixedHeader: true,
        },
        {
          label: "Action",
          field: "delete",
          sort: "disabled",
          width: 100,
          fixed: true,
        },
      ],
      rows: categoryData.map((e) => {
        let current = e;
        // let count = 0
        // console.log(current)
        // count++;
        return Object.assign(e, {
          // 'count': <div>{count + 1}</div>,
          Image: <img width={30} src={e.Image} alt="" />,
          delete: (
            <div className="d-flex justify-content-center">
              {/* <button className='btn btn-primary btn-sm py-1 px-2' onClick={() => getAllSubCategories(e.id, true, e.category)}>Details</button> */}
              <img
                // height={24}

                onClick={() => getAllSubCategories(e.id, true, e.category)}
                data-toggle="tooltip"
                data-placement="bottom"
                title="Details"
                role="button"
                src={DetailsImg}
                alt=""
              />
              {/* <FaUserEdit
                onClick={() => CategoryEdit(e.id)}
                data-toggle="tooltip"
                data-placement="bottom"
                title="Edit"
                role="button"
                size={25}
                color="#007BFF"
              /> */}
              <img
                className="mx-2"
                data-toggle="tooltip"
                data-placement="bottom"
                title="Edit"
                role="button"
                onClick={() => CategoryEdit(e.id)}
                src={FaUserEdit}
                alt=""
              />
              {localStorage.getItem("roles") == "administrator" ? (
                // <MdDeleteForever
                //   data-toggle="tooltip"
                //   data-placement="bottom"
                //   title="Delete"
                //   color="#007BFF"
                //   role="button"
                //   size={25}
                //   onClick={() => handleDelete(e.id, e.category)}
                // />
                <img
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Delete"
                  role="button"
                  onClick={() => handleDelete(e.id, e.category)}
                  src={MdDeleteForever}
                  alt=""
                />
              ) : (
                ""
              )}
              {/* <MdDeleteForever data-toggle="tooltip" data-placement="bottom" title="Delete"
                                onClick={() => handleDelete(e.id)}
                                size={25} color='#0d6efd' role='button'
                            /> */}
            </div>
          ),
          // checkbox: <div><input onChange={(e) => onchangeAuhtor(e, current)} type="checkbox" name="" id=""
          //     // checked={isChecked}
          //     checked={checkedRows.includes(current.id)}
          // /></div>
        });
      }),
    }),
    [categoryData]
  );
  // category

  // subcategory
  const data2 = useMemo(
    () => ({
      columns: [
        // {
        //     label: '#',
        //     field: 'count',
        //     width: 300,
        //     sort: 'disabled',
        //     fixedHeader: true
        // },
        // {
        //     label: 'Image',
        //     field: 'Image',
        //     width: 50,
        //     sort: 'disabled',
        //     fixedHeader: true
        // },
        {
          label: "SubCategory Name",
          field: "category",
          width: 300,
          sort: "",
          fixedHeader: true,
        },
        {
          label: "Authors",
          field: "author",
          width: 300,
          sort: "",
          fixedHeader: true,
        },
        {
          label: "Articles",
          field: "article",
          width: 300,
          sort: "",
          fixedHeader: true,
        },
        {
          label: "Action",
          field: "delete",
          sort: "disabled",
          width: 100,
          fixed: true,
        },
      ],
      rows: subCategoryData.map((e) => {
        let current = e;
        // let count = 0
        // console.log(current)
        // count++;
        return Object.assign(e, {
          // 'count': <div>{count + 1}</div>,
          Image: <img width={30} src={e.Image} alt="" />,
          delete: (
            <div className="d-flex justify-content-center">
              {/* <button className='btn btn-primary ' onClick={() => getAllSubCategories(e.id, true)}>Details</button> */}
              {/* <FaUserEdit
                onClick={() => editSubCategory(e.id)}
                data-toggle="tooltip"
                data-placement="bottom"
                title="Edit"
                role="button"
                size={25}
                color="#007BFF"
              /> */}
              <img
                className="mx-2"
                data-toggle="tooltip"
                data-placement="bottom"
                title="Edit"
                role="button"
                onClick={() => editSubCategory(e.id)}
                src={FaUserEdit}
                alt=""
              />
              {localStorage.getItem("roles") == "administrator" ? (
                // <MdDeleteForever
                //   data-toggle="tooltip"
                //   data-placement="bottom"
                //   title="Delete"
                //   onClick={() => handleDeleteSubcategory(e.id, e.category)}
                //   size={25}
                //   color="#0d6efd"
                //   role="button"
                // />
                <img
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Delete"
                  role="button"
                  onClick={() => handleDeleteSubcategory(e.id, e.category)}
                  src={MdDeleteForever}
                  alt=""
                />
              ) : (
                ""
              )}
            </div>
          ),
          // checkbox: <div><input onChange={(e) => onchangeAuhtor(e, current)} type="checkbox" name="" id=""
          //     // checked={isChecked}
          //     checked={checkedRows.includes(current.id)}
          // /></div>
        });
      }),
    }),
    [categoryData]
  );
  // subcategory
  const editSubCategory = (id) => {
    setShow(true);
    setOpenEditSubCat(true);
    setEditSubCategoryId(id);
    axios
      .get(`${API_BASE_URL}/wp-json/wp/v2/categories/${id}`, config)
      .then((res) => {
        console.log("417=", res.data.parent);
        setFormData({
          name: res.data.name,
          id: res.data.id,
          parent_id: res.data.parent,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleCloseEditSubCat = () => {
    setShow(false);
    setCategoryModalShow(false);
    setShortName("");
    // setCreateUsersShow(false)
    // setCreateUsersFormData({ username: '', email: '', password: '', selectedRole: '' })
    // setErrors("")
  };

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    // console.log(`231 name= ${name}. value= ${value}`)

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const updateSubCat = (id) => {
    setSubCategoryLoading(false);
    // subCategoryLoading(subCategory == true ? false : true)
    console.log(formData);
    console.log(id);
    if (formData.name == "") {
      toast.error("Enter SubCategory Name");
      return;
    } else {
      const data = {
        name: formData.name,
        parent_id: categoryId,
      };
      // axios.post(`${API_BASE_URL}/wp-json/wp/v2/categories/${id}`, data, config).then((res) => {
      axios
        .post(
          `${API_BASE_URL}/wp-json/custom-category/v1/update-subcategory/${editSubCategoryId}`,
          data,
          config
        )
        .then((res) => {
          toast.success("SubCategory Updated Successfully");
          setCatetoryIconUptated(catetoryIconUptated ? false : true);

          // notification count start
          setNotificationCount(notificationCount + 1);

          let notification_count_specific_user = {
            user_id: localStorage.getItem("current_user_Id"),
            count_value: res.data.count_value + 1,
          };
          let notification_count = {
            user_id: "",
            count_value: notificationCount,
            reflect_count: "all_admin",
          };
          if (notification_count.user_id == "") {
            // post notification on usermeta start
            axios
              .post(
                `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
                notification_count,
                config
              )
              .then((res) => {
                console.log(res.data);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          if (notification_count_specific_user.user_id != "") {
            // post notification on usermeta start
            axios
              .post(
                `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
                notification_count_specific_user,
                config
              )
              .then((res) => {
                console.log(res.data);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          // notification count end

          // recomandation data

          let notification_api_data = {
            author: localStorage.getItem("display_name"),
            // name: createUsersFormData.username,
            event_type: "Update Subcategory",
            subcategory_name: formData.name,
            email: localStorage.getItem("userEmail"),
            // user_role: createUsersFormData.selectedRole,
            author_ids: localStorage.getItem("current_user_Id"),
            notification_ids: localStorage.getItem("current_user_Id"),
          };

          axios
            .post(
              `${API_BASE_URL}/wp-json/custom/v1/insert-notification-data`,
              notification_api_data,
              config
            )
            .then((res) => {
              console.log(res.data);
            })
            .catch((err) => {
              console.log(err);
            });

          // recomandation data
          setSubCategoryLoading(true);
          setShow(false);
        }).catch((error) => {
          console.log(error);
          toast.error(error?.response?.data.message)
          // Handle any errors here
        })
    }
  };

  // edit category

  function extractDataInParentheses(inputString) {
    var match = inputString.match(/\(([^)]+)\)/);
    return match ? match[1] : null;
  }
  function extractDataOutsideParentheses(inputString) {
    var match = inputString.match(/^[^(]*|(?<=\))[^(]*$/g);
    return match ? match.join("").trim() : null;
  }
  const CategoryEdit = (id) => {
    // setCategoryModalShow(true)
    // alert(id)
    setEditCategoryModalShow(true);

    axios
      .get(
        `${API_BASE_URL}/wp-json/custom-category/v1/get-category/${id}`,
        config
      )
      .then((res) => {
        console.log(res.data);

        var shortName = res.data.name;
        var extractedShortName = extractDataInParentheses(shortName);
        setShortName(extractedShortName);

        var fullName = res.data.name;
        var extractedName = extractDataOutsideParentheses(fullName);

        setCategoryFormData({
          id: res.data.id,
          image: res.data.image,
          name: extractedName,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChangeUpdateCategory = (e) => {
    if (e.target.name === "name") {
      setCategoryFormData({ ...categoryFormData, name: e.target.value });
    } else if (e.target.name === "image") {
      // setCategoryFormData({ ...categoryFormData, image: e.target.files[0] });
      setUpdateCategoryImage(e.target.files[0]);
    }
  };
  const updateCategory = (id) => {
    console.log(id);
    console.log("abc=", UpdatecategoryImage);

    if (categoryFormData.name == "") {
      toast.error("Enter Category Name");
      // setCategoryModalShow(true)
      return;
    } else if (shortName == "") {
      toast.error("Enter Short Name");

      // setCategoryModalShow(true)
      return;
    }

    if (UpdatecategoryImage) {
      const img = new Image();

      img.onload = async () => {
        if (
          img.width === img.height &&
          UpdatecategoryImage.size < 1 * 1024 * 1024
        ) {
          // alert("if")
          const formData = new FormData();
          formData.append("name", categoryFormData.name + ` (${shortName})`);
          formData.append("image", UpdatecategoryImage);
          console.log("formData=", formData);
          setCtegoryLoading(false);

          axios
            .post(
              `${API_BASE_URL}/wp-json/custom-category/v1/update-category/${id}`,
              formData,
              config2
            )
            .then((res) => {
              setShortName("");
              setEditCategoryModalShow(false);
              console.log(res.data);
              setCtegoryLoading(true);
              setCategoryModalShow(false);
              toast.success("Category Updated Successfully");
              setCatetoryIconUptated(catetoryIconUptated ? false : true);
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          // alert("else")
          toast.error(
            "Please upload image with same height and width & image max size should less then 1MB "
          );
          // toast.error("Please upload image with same height and width ");
        }
      };

      img.src = URL.createObjectURL(UpdatecategoryImage);
    } else {
      console.log("523=", shortName);
      const formData = new FormData();
      formData.append("name", categoryFormData.name + ` (${shortName})`);
      // formData.append('image', UpdatecategoryImage);
      console.log("formData=", formData);
      setCtegoryLoading(false);

      axios
        .post(
          `${API_BASE_URL}/wp-json/custom-category/v1/update-category/${id}`,
          formData,
          config2
        )
        .then((res) => {
          console.log(res.data);

          setEditCategoryModalShow(false);
          setCtegoryLoading(true);
          setCategoryModalShow(false);
          toast.success("Category Updated Successfully");

          // notification count start
          setNotificationCount(notificationCount + 1);

          let notification_count_specific_user = {
            user_id: localStorage.getItem("current_user_Id"),
            count_value: res.data.count_value + 1,
          };
          let notification_count = {
            user_id: "",
            count_value: notificationCount,
            reflect_count: "all_admin",
          };
          if (notification_count.user_id == "") {
            // post notification on usermeta start
            axios
              .post(
                `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
                notification_count,
                config
              )
              .then((res) => {
                console.log(res.data);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          if (notification_count_specific_user.user_id != "") {
            // post notification on usermeta start
            axios
              .post(
                `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
                notification_count_specific_user,
                config
              )
              .then((res) => {
                console.log(res.data);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          // notification count end

          // recomandation data

          let notification_api_data = {
            author: localStorage.getItem("display_name"),
            // name: createUsersFormData.username,
            event_type: "Update Category",
            category_name: categoryFormData.name + ` (${shortName})`,
            // user_role: createUsersFormData.selectedRole,
            email: localStorage.getItem("userEmail"),
            author_ids: localStorage.getItem("current_user_Id"),
            notification_ids: localStorage.getItem("current_user_Id"),
          };

          axios
            .post(
              `${API_BASE_URL}/wp-json/custom/v1/insert-notification-data`,
              notification_api_data,
              config
            )
            .then((res) => {
              console.log(res.data);
            })
            .catch((err) => {
              console.log(err);
            });

          // recomandation data
          setShortName("");
          setCatetoryIconUptated(catetoryIconUptated ? false : true);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  // edit category

  // subcategory
  const CretateSubCategoryModalOpen = () => {
    setCreateSubCategoryShow(true);
  };
  const CretateCategoryModalOpen = () => {
    setCategoryModalShow(true);
  };
  const handleShortName = (e) => {
    let sname = e.target.value;
    if (sname.length > 3) {
      toast.error("Short name should be of three characters", {
        toastId: "shortName error",
      });
    } else {
      setShortName(sname.toUpperCase());
    }
  };

  const handleClose = () => {
    setEditCategoryModalShow(false);
    setCategoryModalShow(false);
    setShortName("");
    // setCreateUsersShow(false)
    // setCreateUsersFormData({ username: '', email: '', password: '', selectedRole: '' })
    // setErrors("")
  };
  const handleChangeCreateCategory = (e) => {
    console.log(e.target.value);
    if (e.target.name === "name") {
      setCategoryFormData({ ...categoryFormData, name: e.target.value });
    } else if (e.target.name === "image") {
      // setCategoryFormData({ ...categoryFormData, image: e.target.files[0] });
      setUpdateCategoryImage(e.target.files[0]);
    }
  };
  const createCategory = () => {
    console.log("abc=", UpdatecategoryImage);
    // if (UpdatecategoryImage) {
    const img = new Image();
    console.log(categoryFormData);
    console.log("sname=", shortName);
    if (categoryFormData.name == "") {
      toast.error("Enter Category Name");
      setCategoryModalShow(true);
      return;
    } else if (shortName == "") {
      toast.error("Enter Short Name");

      setCategoryModalShow(true);
      return;
    }
    img.onload = async () => {
      //       if (file.target.files[0].size > 150 * 1024 * 1024) {
      //   toast.error("Maximum upload file size: 150 MB", {
      //     toastId: "largeFile",
      //   });
      //   setIsUploading(false);
      //   // setLargeFile(true)
      //   return 0;
      // }
      if (
        img.width === img.height &&
        UpdatecategoryImage.size < 1 * 1024 * 1024
      ) {
        // alert("if")
        const formData = new FormData();
        formData.append(
          "category_name",
          categoryFormData.name + ` (${shortName})`
        );
        formData.append("category_image", UpdatecategoryImage);
        console.log("formData=", formData);
        setCtegoryLoading(false);

        axios
          .post(
            `${API_BASE_URL}/wp-json/custom-category/v1/upload`,
            formData,
            config2
          )
          .then((res) => {
            console.log(res.data);
            setCtegoryLoading(categoryLoading ? false : true);
            setCategoryModalShow(false);
            toast.success("Category Created Successfully");
            setCatetoryIconUptated(catetoryIconUptated ? false : true);

            // notification count start
            setNotificationCount(notificationCount + 1);

            let notification_count_specific_user = {
              user_id: localStorage.getItem("current_user_Id"),
              count_value: res.data.count_value + 1,
            };
            let notification_count = {
              user_id: "",
              count_value: notificationCount,
              reflect_count: "all_admin",
            };
            if (notification_count.user_id == "") {
              // post notification on usermeta start
              axios
                .post(
                  `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
                  notification_count,
                  config
                )
                .then((res) => {
                  console.log(res.data);
                })
                .catch((err) => {
                  console.log(err);
                });
            }
            if (notification_count_specific_user.user_id != "") {
              // post notification on usermeta start
              axios
                .post(
                  `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
                  notification_count_specific_user,
                  config
                )
                .then((res) => {
                  console.log(res.data);
                })
                .catch((err) => {
                  console.log(err);
                });
            }
            // notification count end

            // recomandation data

            let notification_api_data = {
              author: localStorage.getItem("display_name"),
              // name: createUsersFormData.username,
              event_type: "New Category Created",
              category_name: categoryFormData.name + ` (${shortName})`,
              email: localStorage.getItem("userEmail"),
              // user_role: createUsersFormData.selectedRole,
              author_ids: localStorage.getItem("current_user_Id"),
              notification_ids: localStorage.getItem("current_user_Id"),
            };

            axios
              .post(
                `${API_BASE_URL}/wp-json/custom/v1/insert-notification-data`,
                notification_api_data,
                config
              )
              .then((res) => {
                console.log(res.data);
              })
              .catch((err) => {
                console.log(err);
              });

            // recomandation data
            setShortName("");
          })
          .catch((err) => {
            toast.error(err.response.data.message);
            console.log(err);
          });
      } else {
        // alert("else")
        toast.error(
          "Please upload image with same height and width & image max size should less then 1MB "
        );
      }
    };

    if (UpdatecategoryImage == "") {
      toast.error("Upload Category Image");
      return;
    } else {
      img.src = URL.createObjectURL(UpdatecategoryImage);
      setCategoryModalShow(true);
    }
    // }
  };

  const handleChangeSubCat = (e) => {
    setSubCtegoryName(e.target.value);

    console.log(e.target.value);
  };
  const handleCreateSubcategory = async () => {
    setSubCategoryLoading(false);
    // alert(categoryId)
    const formData = {
      name: subCategoryName,
      parent_id: categoryId,
    };
    console.log(formData);

    // axios.post(`${API_BASE_URL}/wp-json/wp/v2/categories`, formData, config)
    axios
      .post(
        `${API_BASE_URL}/wp-json/custom-category/v1/create-subcategory`,
        formData,
        config
      )
      .then((response) => {
        // Handle the response here
        setCreateSubCategoryShow(false);
        setShowCreateSubCategory(false);
        setSubCategoryLoading(true);

        // notification count start
        setNotificationCount(notificationCount + 1);

        let notification_count_specific_user = {
          user_id: localStorage.getItem("current_user_Id"),
          count_value: "",
        };
        let notification_count = {
          user_id: "",
          count_value: notificationCount,
          reflect_count: "all_admin",
        };
        if (notification_count.user_id == "") {
          // post notification on usermeta start
          axios
            .post(
              `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
              notification_count,
              config
            )
            .then((res) => {
              console.log(res.data);
            })
            .catch((err) => {
              console.log(err);
            });
        }
        if (notification_count_specific_user.user_id != "") {
          // post notification on usermeta start
          axios
            .post(
              `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
              notification_count_specific_user,
              config
            )
            .then((res) => {
              console.log(res.data);
            })
            .catch((err) => {
              console.log(err);
            });
        }
        // notification count end

        // recomandation data

        let notification_api_data = {
          author: localStorage.getItem("display_name"),
          // name: createUsersFormData.username,
          event_type: "Create New Subcategory",
          subcategory_name: subCategoryName,
          email: localStorage.getItem("userEmail"),
          // user_role: createUsersFormData.selectedRole,
          author_ids: localStorage.getItem("current_user_Id"),
          notification_ids: localStorage.getItem("current_user_Id"),
        };

        axios
          .post(
            `${API_BASE_URL}/wp-json/custom/v1/insert-notification-data`,
            notification_api_data,
            config
          )
          .then((res) => {
            console.log(res.data);
          })
          .catch((err) => {
            console.log(err);
          });

        // recomandation data
        toast.success("SubCategory Created Successfully");
        setCatetoryIconUptated(catetoryIconUptated ? false : true);
        console.log(response.data);
        setSubCtegoryName("");
      })
      .catch((error) => {
        console.log(error);
        toast.error(error?.response?.data.message)
        // Handle any errors here
      })
      .finally((err) => {
        // toast.error("File is not uploaded")
      });
  };
  const handleCloseCreateSubCat = () => {
    setCreateSubCategoryShow(false);
  };

  useEffect(() => {
    // alert("kjfvj")
    // const apiUrl = `${API_BASE_URL}/wp-json/wp/v2/categories?per_page=100`
    getAllTheCategories();
    getAllSubCategories(categoryId, false, categoryName);
  }, [categoryLoading]);

  useEffect(() => {
    // alert("kjfvj")
    // const apiUrl = `${API_BASE_URL}/wp-json/wp/v2/categories?per_page=100`
    getAllTheCategories();
    getAllSubCategories(categoryId, true, categoryName);
  }, [subCategoryLoading]);

  useEffect(() => {
    // alert("kjfvj")
    // const apiUrl = `${API_BASE_URL}/wp-json/wp/v2/categories?per_page=100`
    getAllTheCategories();
    getAllSubCategories(categoryId, false);
  }, []);
  return (
    <div>
      <div className="row g-0">
        <div
          style={{ minHeight: "90vh" }}
          className={
            collaps ? "column right-column  col" : "column right-column  col "
          }
        >
          <div className="w-100">
            <NewTopNavBar />
          </div>
          {/* modal start */}

          <div>
            {/* create category */}
            <Modal show={categoryModalShow} onHide={handleClose} centered>
              <Modal.Header closeButton>
                <Modal.Title>Create Category</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {" "}
                <div className="row g-0 w-100 ">
                  <div className="col-3"></div>
                  <div className="col-12">
                    <form>
                      <div className="form-group my-2">
                        {/* <label for="exampleInputEmail1">Category Image:</label> */}
                        <div className="ms-4 my-2">
                          {/* <img height={50} width={50}
                                                    // style={{ width: "100px", height: "100px" }}
                                                    src={categoryFormData.image} alt="" /> */}
                        </div>
                      </div>
                      <div className="form-group">
                        <div>
                          <label className="fw-bold" for="exampleInputEmail1">
                            Note: Max image size should 1MB and it should a
                            square image.
                          </label>
                        </div>
                        <label className="fw-bold" for="exampleInputEmail1">
                          Create Category Image{" "}
                          <span className="text-danger">* </span> :
                        </label>
                        <input
                          className="form-control my-2"
                          type="file"
                          name="image"
                          // value={categoryFormData.image}
                          placeholder="Enter Category name"
                          onChange={handleChangeCreateCategory}
                          accept="image/*"
                          required
                        />
                        {/* {errors.username && <p className="error">{errors.username}</p>} */}
                      </div>
                      <div className="form-group">
                        <label className="fw-bold" for="exampleInputEmail1">
                          Create Category Name{" "}
                          <span className="text-danger">* </span> :
                        </label>
                        <input
                          className="form-control my-2"
                          type="text"
                          name="name"
                          // value={categoryFormData.name}
                          placeholder="Enter Category name"
                          onChange={handleChangeCreateCategory}
                          required
                        />

                        <label className="fw-bold" for="exampleInputEmail1">
                          Create Short Name{" "}
                          <span className="text-danger">* </span> :
                        </label>
                        <input
                          className="my-2 form-control"
                          placeholder="Short name "
                          type="text"
                          name="shortName"
                          value={shortName}
                          onChange={handleShortName}
                          required
                        />

                        {/* {errors.username && <p className="error">{errors.username}</p>} */}
                      </div>

                      {/*  */}
                      <div className="mt-2 text-end">
                        {/* <button onClick={() => createCategory()} type="button" className="btn btn-primary">Create</button> */}
                        <img
                          className="commonLogo"
                          // height={40}
                          onClick={() => createCategory()}
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title="Create Category"
                          role="button"
                          src={UpdateCategoryImg}
                          alt=""
                        />
                      </div>
                    </form>
                  </div>
                  <div className="col-3"></div>
                </div>
              </Modal.Body>
            </Modal>
            {/* create category */}

            {/* update category */}
            <Modal show={editCategoryModalShow} onHide={handleClose} centered>
              <Modal.Header closeButton>
                <Modal.Title>Edit Category</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {" "}
                <div className="row g-0 w-100 ">
                  <div className="col-3"></div>
                  <div className="col-12">
                    <form>
                      <div className="form-group my-2">
                        {/* <label for="exampleInputEmail1">Category Image:</label> */}
                        <div className="ms-4 my-2">
                          <img
                            height={50}
                            width={50}
                            // style={{ width: "100px", height: "100px" }}
                            src={categoryFormData.image}
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <div>
                          <label className="fw-bold" for="exampleInputEmail1">
                            Note: Max image size should 1MB and it should a
                            square image.
                          </label>
                        </div>
                        <label className="fw-bold" for="exampleInputEmail1">
                          Update Category Image{" "}
                          <span className="text-danger">* </span> :
                        </label>
                        <input
                          className="form-control my-2"
                          type="file"
                          name="image"
                          // value={categoryFormData.image}
                          placeholder="Enter Category name"
                          onChange={handleChangeUpdateCategory}
                          accept="image/*"
                          required
                        />
                        {/* {errors.username && <p className="error">{errors.username}</p>} */}
                      </div>
                      <div className="form-group">
                        <label className="fw-bold" for="exampleInputEmail1">
                          Update Category Name
                          <span className="text-danger">* </span> :
                        </label>
                        <input
                          className="form-control my-2"
                          type="text"
                          name="name"
                          value={categoryFormData.name}
                          placeholder="Enter Category name"
                          onChange={handleChangeUpdateCategory}
                          required
                        />

                        <label className="fw-bold" for="exampleInputEmail1">
                          Update Short Name{" "}
                          <span className="text-danger">* </span> :
                        </label>
                        <input
                          className="my-2 form-control"
                          placeholder="Short name "
                          type="text"
                          name="shortName"
                          value={shortName}
                          onChange={handleShortName}
                          required
                        />

                        {/* {errors.username && <p className="error">{errors.username}</p>} */}
                      </div>

                      {/*  */}
                      <div className="mt-2 text-end">
                        {/* <button onClick={() => updateCategory(categoryFormData.id)} type="button" className="btn btn-primary">Update</button> */}
                        <img
                          className="commonLogo"
                          // height={40}
                          onClick={() => updateCategory(categoryFormData.id)}
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title="Update"
                          role="button"
                          src={UpdateImg}
                          alt=""
                        />
                      </div>
                    </form>
                  </div>
                  <div className="col-3"></div>
                </div>
              </Modal.Body>
            </Modal>
            {/* update category */}

            {/* create subcategory */}
            <Modal
              show={createSubCategoryShow}
              onHide={handleCloseCreateSubCat}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Create SubCategory</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row g-0 w-100 ">
                  <div className="col-3"></div>
                  <div className="col-12">
                    {/* <form onClick={(e) => e.preventDefault()}> */}
                    <div className="form-group">
                      <label className="fw-bold pb-2" for="exampleInputEmail1">
                        Sub Category Name{" "}
                        <span className="text-danger">* </span> :
                      </label>
                      <div className=" mb-2">
                        <input
                          className="p-1 form-control "
                          type="text"
                          placeholder="Enter subcategory name"
                          // value={newSubcategory[category.id]}
                          onChange={(e) => handleChangeSubCat(e)}
                        />
                        <div className="text-end mt-2">
                          {/* <button className='btn btn-primary  my-0' onClick={() => handleCreateSubcategory()}>
                                                        Create
                                                    </button> */}
                          <img
                            className="commonLogo"
                            // height={40}
                            onClick={() => handleCreateSubcategory()}
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Create Subcategory"
                            role="button"
                            src={UpdateCategoryImg}
                            alt=""
                          />
                        </div>
                      </div>
                      {/* </form> */}
                    </div>
                    <div className="col-3"></div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
            {/* create subcategory */}
            {/* update sub category */}
            <Modal show={show} onHide={handleCloseEditSubCat} centered>
              <Modal.Header closeButton>
                <Modal.Title>Edit SubCategory</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {" "}
                <div className="row g-0 w-100 ">
                  <div className="col-3"></div>
                  <div className="col-12">
                    {/* <form onClick={(e) => e.preventDefault()}> */}
                    <div className="form-group">
                      <label className="fw-bold pb-2" for="exampleInputEmail1">
                        Sub Category Name{" "}
                        <span className="text-danger">* </span> :
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        name="name"
                        value={formData.name}
                        placeholder="Enter Sub category name"
                        onChange={handleChange}
                        onClick={(e) => e.stopPropagation()}
                      />
                      {/* {errors.username && <p className="error">{errors.username}</p>} */}
                    </div>

                    {/*  */}
                    <div className="mt-2 text-end">
                      {/* <button onClick={() => updateSubCat()} type="button" className="btn btn-primary">Update</button> */}
                      <img
                        className="commonLogo"
                        // height={40}
                        onClick={() => updateSubCat()}
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Update"
                        role="button"
                        src={UpdateImg}
                        alt=""
                      />
                    </div>
                    {/* </form> */}
                  </div>
                  <div className="col-3"></div>
                </div>
              </Modal.Body>
            </Modal>
            {/* update sub category */}
          </div>

          {/* modal end */}
          {loader ? (
            <div>
              {subCategoryScreen ? (
                <div
                  className="w-100"
                  style={{
                    minHeight: "80vh",
                    padding: "15px 20px 10px 40px",
                  }}
                >
                  <div
                    style={{
                      // background: '#ececec',
                      boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.5)",
                      // padding:""
                      // margin: '20px 30px'
                    }}
                    className="row w-100"
                  >
                    <div className="col-12 px-5 pt-2">
                      <div className="row g-0">
                        <div className="col-3">
                          {/* <button className='btn btn-primary m-3 mt-4' onClick={CategoryPage}>Back</button> */}
                          <img
                            className="mt-3 ms-2 "
                            // height={40}
                            onClick={CategoryPage}
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Back"
                            role="button"
                            src={BackImg}
                            alt=""
                          />
                        </div>
                        <div className="col-6">
                          <div className="pt-3">
                            {/* <h2 className='text-center'>Knowledge Repository</h2> */}
                            <h5 className="text-center pt-1">
                              {" "}
                              Parent Category:
                              {/* {localStorage.getItem('categoryName')} */}
                              {categoryName}
                            </h5>
                            {/* <h5 className='text-center'> Parent Category: {categoryName} </h5> */}
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="text-end pt-3 pe-2">
                            {/* <button onClick={CretateSubCategoryModalOpen} className='btn btn-primary'>Create SubCategory</button> */}
                            <img
                              className="me-1 commonLogo"
                              // height={40}
                              onClick={CretateSubCategoryModalOpen}
                              data-toggle="tooltip"
                              data-placement="bottom"
                              title="Create Subcategory"
                              role="button"
                              src={CreateSubCatImg}
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        {rolles == "administrator" ? (
                          <MDBDataTable
                            // noRecordsFoundLabel={`${articleData.length < 1 ? 'Create your first article  by clicking on "+ CREATE ARTICLE" button' : 'No matching records found'}`}
                            fixed
                            sortable
                            bordered
                            autoWidth={false}
                            data={data2}
                            entries={5}
                            entriesOptions={[5, 10, 15, 20]}
                            noBottomColumns
                            disableRetreatAfterSorting={true}
                          />
                        ) : (
                          <MDBDataTable
                            // noRecordsFoundLabel={`${articleData.length < 1 ? 'Create your first article  by clicking on "+ CREATE ARTICLE" button' : 'No matching records found'}`}
                            fixed
                            sortable
                            bordered
                            autoWidth={false}
                            data={data2}
                            entries={5}
                            entriesOptions={[5, 10, 15, 20]}
                            noBottomColumns
                            disableRetreatAfterSorting={true}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className="w-100"
                  style={{
                    minHeight: "80vh",
                    padding: "15px 20px 10px 40px",
                  }}
                >
                  <div
                    style={{
                      // background: '#ececec',
                      boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.5)",
                      // margin: '20px 30px'
                    }}
                    className="row w-100"
                  >
                    <div className="col-12 px-5 pt-2">
                      <div className="row g-0 ">
                        <div className="col-8 ">
                          <div className="pt-3 ">
                            {/* <h2 className='text-center'>Knowledge Repository</h2> */}
                            <h2 className="">Manage Categories</h2>
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="text-end pt-4 pe-2">
                            {/* <button onClick={CretateCategoryModalOpen} className='btn btn-primary'>Create Category</button> */}
                            <img
                              className="me-1 commonLogo"
                              // height={40}
                              onClick={CretateCategoryModalOpen}
                              data-toggle="tooltip"
                              data-placement="bottom"
                              title="Create Category"
                              role="button"
                              src={CreateCategoryImg}
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        {rolles == "administrator" ? (
                          <MDBDataTable
                            // noRecordsFoundLabel={`${articleData.length < 1 ? 'Create your first article  by clicking on "+ CREATE ARTICLE" button' : 'No matching records found'}`}
                            fixed
                            sortable
                            bordered
                            autoWidth={false}
                            data={data}
                            entries={5}
                            entriesOptions={[5, 10, 15, 20]}
                            noBottomColumns
                            disableRetreatAfterSorting={true}
                          />
                        ) : (
                          <MDBDataTable
                            // noRecordsFoundLabel={`${articleData.length < 1 ? 'Create your first article  by clicking on "+ CREATE ARTICLE" button' : 'No matching records found'}`}
                            fixed
                            sortable
                            bordered
                            autoWidth={false}
                            data={data}
                            entries={5}
                            entriesOptions={[5, 10, 15, 20]}
                            noBottomColumns
                            disableRetreatAfterSorting={true}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="text-center w-100 my-5">
              <Spinner />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateCategories;
